import { Component, Fragment, getAssetPath, h } from '@stencil/core';
import state from '../../store';

@Component({
  tag: 'hemfixarna-info',
  shadow: false,
})
export class HemfixarnaInfo {
  logo = getAssetPath(`./assets/hemfixarna.svg`);

  render() {
    const checked = getAssetPath(`./assets/checked.svg`);
    return (
      <div class="hemfixarna_info">
        {state.step < 5 ? (
          <Fragment>
            <h2>{state.customer.info_title}</h2>
            <p>{state.customer.info_text}</p>
          </Fragment>
        ) : (
          <h2>{state.customer.checkout_title}</h2>
        )}
        <ul class="hemfixarna_features">
          {state.step < 5 ? (
            <Fragment>
              {state.customer.trust_badges?.length ? (
                <Fragment>
                  {state.customer.trust_badges.map(l => (
                    <li key={l.text}>
                      <img src={checked} alt="checked" />
                      <p>{l.text}</p>
                    </li>
                  ))}
                </Fragment>
              ) : (
                <Fragment>
                  {state.options.trust.map(l => (
                    <li key={l.trust_badge}>
                      <img src={checked} alt="checked" />
                      <p>{l.trust_badge}</p>
                    </li>
                  ))}
                </Fragment>
              )}
            </Fragment>
          ) : (
            <Fragment>
              {state.customer.checkout_trust_badges?.map(l => (
                <li key={l.text}>
                  <img src={checked} alt="checked" />
                  <p>{l.text}</p>
                </li>
              ))}
            </Fragment>
          )}
        </ul>
        <img src={this.logo} width={200} alt="hemfixarna" />
        <a class="hemfixarna_product--link" target="_blank" href={state.options.link.url}>
          {state.options.link.title}
        </a>
      </div>
    );
  }
}
